import React, { useEffect, useState } from 'react'
import { EmailIcon } from '@entur/icons'
import { useToast } from '@entur/alert'
import { OverflowMenuItem } from '@entur/menu'
import { WelcomeLetterModal } from './welcome-letter-modal'
import { useDownloadableApi } from '../../api-clients/client-hooks'
import { useEmployee } from '../../contexts/employee-context'
import { trackEvent } from '../../utils/tracking-utils'
import { FamilyMember, Fetch, FetchState } from '../../api-clients/api-types'
import { generateWelcomeLetter } from '../../api-clients/eba-clients'

type WelcomeLetterProps = {
  familyMembers: Fetch<FamilyMember[]>
  setErrorMessage: (errorMsg: string | undefined) => void
}

export const WelcomeLetter: React.FC<WelcomeLetterProps> = ({ familyMembers, setErrorMessage }) => {
  const { employee } = useEmployee()
  const [open, setOpen] = useState(false)
  const { addToast } = useToast()
  const [welcomeLetterResponse, downloadWelcomeLetter] = useDownloadableApi(generateWelcomeLetter)

  useEffect(() => {
    if (welcomeLetterResponse.status === FetchState.ERROR) {
      setErrorMessage('Kan ikke lage velkomstbrev')
    }
  }, [welcomeLetterResponse, setErrorMessage])

  const openModalOrDownloadWelcomeLetter = () => {
    const shouldShowWelcomeLetterModal =
      (familyMembers.status === FetchState.SUCCESS && familyMembers.data.length > 0) ||
      familyMembers.status !== FetchState.SUCCESS

    if (shouldShowWelcomeLetterModal) {
      trackEvent('Download-Welcome-Letter', { category: 'Employee' })
      setOpen(true)
    } else {
      addToast({ variant: 'info', content: 'Laster ned velkomstbrev...' })
      downloadWelcomeLetter({
        body: {
          ticketRightHolderCodes: [employee.ticketHolderCode],
        },
        backupFileName: `velkomstbrev.pdf`,
      })
    }
  }

  return (
    <>
      <OverflowMenuItem
        data-cy="welcome-letter-button"
        className="welcome-letter-button"
        onSelect={openModalOrDownloadWelcomeLetter}
      >
        <span aria-hidden>
          <EmailIcon inline />
          Velkomstbrev
        </span>
      </OverflowMenuItem>
      <WelcomeLetterModal
        employee={employee}
        familyMembersResponse={familyMembers}
        open={open}
        download={downloadWelcomeLetter}
        downloadResponse={welcomeLetterResponse}
        close={() => setOpen(false)}
      />
    </>
  )
}
